import { Component, ElementRef, Input, OnChanges, ViewChild } from '@angular/core';
import { EfMainExternalFilter } from 'pg-lib/experience-finder/ef-main/ef-main.component';
import { EfMapComponent } from 'pg-lib/experience-finder/elements/ef-map/ef-map.component';
import { EFItineraryContent, EFProduct, EFSupplier } from 'pg-lib/models/experience.model';
import { AnalyticsService } from 'pg-lib/services/analytics.service';
import { EFDataService } from 'pg-lib/services/ef-data.service';
import { EnvironmentService } from 'pg-lib/services/environment.service';
import { LocalizationService } from 'pg-lib/services/localization.service';
import { TotemWidget, TotemWidgetProductsFilter } from '../totem-widget';

@Component({
    selector: 'app-totem-widget-products',
    templateUrl: './totem-widget-products.component.html',
    styleUrls: ['./totem-widget-products.component.scss'],
    standalone: false
})
export class TotemWidgetProductsComponent extends TotemWidget implements OnChanges {

    size:'md'|'lg' = 'lg';

    @Input() productsData:Array<EFProduct>;
    @Input() filter:TotemWidgetProductsFilter;
    @Input() showMap:boolean;
    @Input() showText:any;
    @Input() verticalList:boolean;
    @Input() noFullScreen:boolean;
    @Input() fullScreenView:string;
    @Input() mixTypes:boolean;

    filteredData:Array<EFProduct>;

    selectedProductId:string = null;
    selectedProductData:EFProduct = null;
    selectedProductSupplierData:EFSupplier = null;

    isLoadingProduct = false;

    imageList:Array<{ file: string, text: string, author: string }> = [];

    constructor(public elementRef:ElementRef, private environmentService:EnvironmentService, private localizationService:LocalizationService, private efDataService:EFDataService, private analyticsService:AnalyticsService) {
        super(elementRef);
    }

    @ViewChild('efMapComponent') efMapComponent:EfMapComponent;

    onInactive() {
        if(this.efMapComponent != null) this.efMapComponent.centerMap(true)
    }

    externalFilter:EfMainExternalFilter = null;

    ngOnInit(): void {
        this.size = (this.verticalList || this.showText != null) ? 'md' : 'lg'

        this._checkInitializeWidget();
    }

    ngOnChanges() {
        this._checkInitializeWidget();
    }
    
    isInitialized = false;

    private _checkInitializeWidget() {
        if(!this.isInitialized && this.productsData != null) {
            this.isInitialized = true;

            for(let i = 0; i < this.productsData.length; i++) {
                if(!(this.productsData[i] instanceof EFProduct)) {
                    this.productsData[i] = new EFProduct(this.environmentService, this.localizationService, this.productsData[i].type, this.productsData[i], this.productsData[i].resource)
                }
            }

            if(this.fullScreenParams) {
                this.selectedProductId = this.fullScreenParams;

                this.isLoadingProduct = true;

                this.efDataService.getProductDetail(this.selectedProductId).subscribe((data) => {

                    this.selectedProductData = data;

                    if(data?.analytics != null) {
                        this.analyticsService.sendEvent('showProduct', data.analytics)
                    }

                    if(this.selectedProductData != null && this.selectedProductData.supplier != null) {
                        let _supplierSplit = this.selectedProductData.supplier.split('_');
    
                        this.efDataService.getResourceSupplier(_supplierSplit[0], _supplierSplit[1]).subscribe((data) => {
                            this.selectedProductSupplierData = data;
                            this.isLoadingProduct = false;
                        })
                    }
                    else {
                        this.isLoadingProduct = false;
                    }
                })

            }
            else {
                this.filteredData = this.applyProductsFilter(this.productsData, this.filter)

                this.externalFilter = { past: false }

                for(let i in this.filter) {
                    let _val = this.filter[i];

                    if(typeof _val == 'string') {
                        if(_val != '') {
                            this.externalFilter[i] = _val;

                            if(_val.startsWith('[') && _val.endsWith(']')) {
                                try {
                                    this.externalFilter[i] = JSON.parse(_val).join(',');
                                }
                                catch(ex) {
                                    console.log(ex)
                                }
                            }
                        }
                    }
                    else {
                        if(_val != null) {
                            this.externalFilter[i] = _val.join(',');
                        }
                    }
                }
        
                for(let _product of this.filteredData) {
                    let _imageFile = _product.cover || _product.images[0];
        
                    if(_imageFile != null) {
                        let _resource = _product.resource;
                        _resource = _resource.charAt(0).toUpperCase() + _resource.substring(1)
        
                        let _categoryTransl = this.localizationService.translate('RESOURCES.' + _resource + '.name');
                        
                        if(_resource == 'Host' || _resource == 'Eatery') {
                            if(_product.category != null) {
                                _categoryTransl += ' - ' + this.localizationService.translate('OPTIONMAPS.' + _resource + '.type.' + _product.category);
                            }
                        }
                        else {
                            if(_product.category != null) {
                                _categoryTransl += ' - ' + this.localizationService.translate('OPTIONMAPS.' + _resource + '.category.' + _product.category);
                            }
                        }
            
                        this.imageList.push({
                            file: _imageFile,
                            text: _product.title,
                            author: _categoryTransl
                        })
                    }
                }
        
                setTimeout(() => {
                    if(this.efMapComponent != null) this.efMapComponent.centerMap(true)
                }, 1000)
            }
        }
    }

    onShowProduct(product:string) {
        if(this.fullScreen) {
            // TODO: questa cosa è da fixare, non funziona
            this.selectedProductId = product
        }
        else {
            if(this.noFullScreen) {
                for(let _product of this.productsData) {
                    if(_product.id == product) {
                        if(_product.link != null && _product.link.url != null) {
                            window.open(_product.link.url)
                        }
                        break;
                    }
                }
            }
            else {
                this.requestFullScreen.emit({ params: product })
            }
        }
    }

    onShowStop(stop:EFItineraryContent) {
        
    }

    onRequestFullScreen(index?:number) {
        if(!this.noFullScreen) this.requestFullScreen.emit({ params: index == null ? null : this.productsData[index].id })
    }
}
